<template>
  <div
    class="cart__discount-progress-bar mb-xs"
    v-if="
      cartStore.totalCartItems &&
      !discountStore.campaignDiscountCode &&
      !discountStore.discountCode
    "
  >
    <div class="discount-progress-bar mt-md mr-md">
      <ProgressBar
        :value="cartDiscountProgress.currentProgress"
        :is-animated="true"
        :is-striped="true"
        size="sm"
      >
      </ProgressBar>
      <div>
        <div
          class="discount-progress-bar__marker"
          :class="{ 'discount-progress-bar__marker--passed': marker.isPassed }"
          v-for="(marker, index) of cartDiscountProgress.markers"
          :key="index"
          :style="{ left: marker.position + '%' }"
        >
          <span
            class="discount-progress-bar__marker-label discount-progress-bar__marker-label--top"
          >
            {{ marker.discountLabel ? '-' + marker.discountLabel : '' }}
          </span>
          <span
            class="discount-progress-bar__marker-label discount-progress-bar__marker-label--bottom"
          >
            {{ marker.conditionLabel }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import ProgressBar from '@/ui-kits/ProgressBar.vue'
import { computed } from 'vue'
import useCartStore from '@/store/cart'
import useDiscountStore from '@/store/discount'

const discountStore = useDiscountStore()
const cartStore = useCartStore()

const cartDiscountProgress = computed(() => ({
  currentProgress:
    cartStore.totalCartItems == 1
      ? 12
      : cartStore.totalCartItems == 2
      ? 40
      : cartStore.totalCartItems == 3
      ? 70
      : 100,
  markers: [
    {
      isPassed: cartStore.totalCartItems == 1,
      position: 10,
      conditionLabel: '1 item',
      discountLabel: '',
    },
    {
      isPassed: cartStore.totalCartItems == 2,
      position: 40,
      conditionLabel: '2 items',
      discountLabel: '5% OFF',
    },
    {
      isPassed: cartStore.totalCartItems == 3,
      position: 70,
      conditionLabel: '3 items',
      discountLabel: '10% OFF',
    },
    {
      isPassed: cartStore.totalCartItems >= 4,
      position: 100,
      conditionLabel: '4 items',
      discountLabel: '15% OFF',
    },
  ],
}))
</script>

<style lang="scss">
.cart__discount-progress-bar {
  .discount-progress-bar {
    position: relative;
    $S: &;
    &__marker {
      --size: 1rem;
      position: absolute;
      top: 50%;
      left: 0;
      width: var(--size);
      height: var(--size);
      background-color: #fff;
      border-radius: 50%;
      transform: translate(-50%, -50%);
      border: solid 1px var(--border-color);

      &--passed {
        background-color: var(--color-primary);
        border: solid 1px #fff;
        #{$S}__marker-label {
          color: var(--text-color-primary);
        }
      }

      &:first-child {
        transform: translate(0, -50%);
        #{$S}__marker-label {
          transform: translateX(0);
          left: 0;
        }
      }
      &:last-child {
        transform: translate(-100%, -50%);
        #{$S}__marker-label {
          transform: translateX(0);
          left: auto;
          right: 0;
        }
      }
    }
    &__marker-label {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      white-space: nowrap;
      font-size: 0.875rem;
      color: var(--text-color-tertiary);
      &--top {
        top: -170%;
      }
      &--bottom {
        top: 160%;
      }
    }
    margin-bottom: 2.2rem;
  }

  .discount-progress-message {
    font-size: 12px;
    color: var(--color-primary);
  }
}
.discount-progress-bar__marker--passed span {
  color: var(--text-color-primary) !important;
}
</style>
